import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerAccount from "@/pages/CustomerAccount";
import Contact from "@/pages/Contact";
import Blogs from "@/pages/Blogs";
import Pricing from "@/pages/Pricing";
import Highlighted from "@/pages/Highlighted";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center"><div className="h-8 w-8 rounded-full border-2 border-[color:var(--wine)] border-t-transparent animate-spin"/></div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace/>;
  return children;
}

function PageShell({ children }) {
  return (
    <motion.div initial={{opacity:0, y:12}} animate={{opacity:1, y:0}} exit={{opacity:0}} transition={{duration:0.35}}>
      {children}
    </motion.div>
  );
}

function AppRoutes() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<PageShell><Home/></PageShell>}/>
        <Route path="/properties" element={<PageShell><Properties/></PageShell>}/>
        <Route path="/property/:id" element={<PageShell><PropertyDetail/></PageShell>}/>
        <Route path="/highlighted" element={<PageShell><Highlighted/></PageShell>}/>
        <Route path="/blogs" element={<PageShell><Blogs/></PageShell>}/>
        <Route path="/pricing" element={<PageShell><Pricing/></PageShell>}/>
        <Route path="/contact" element={<PageShell><Contact/></PageShell>}/>
        <Route path="/login" element={<PageShell><Login/></PageShell>}/>
        <Route path="/register" element={<PageShell><Register/></PageShell>}/>
        <Route path="/forgot-password" element={<PageShell><ForgotPassword/></PageShell>}/>
        <Route path="/reset-password" element={<PageShell><ResetPassword/></PageShell>}/>
        <Route path="/owner" element={<Protected roles={["venue_owner","staff","super_admin","major_admin","admin"]}><PageShell><OwnerDashboard/></PageShell></Protected>}/>
        <Route path="/admin" element={<Protected roles={["super_admin","major_admin"]}><PageShell><AdminDashboard/></PageShell></Protected>}/>
        <Route path="/account" element={<Protected roles={["customer","staff","venue_owner","super_admin","major_admin","admin"]}><PageShell><CustomerAccount/></PageShell></Protected>}/>
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar/>
          <main>
            <AppRoutes/>
          </main>
          <Footer/>
          <Toaster position="top-center" richColors/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
